import {
    createSelector
} from 'reselect';

const getValues = (state, ownProps) => ownProps.values;
const getSearch = (state, ownProps) => ownProps.search;
const getSelected = (state, ownProps) => ownProps.selected;

export const selectFilteredValues = createSelector(
    [getValues, getSearch, getSelected],
    (values, search, selected) => {
        const searchFormatted = search ? search.toLowerCase().trim() : '';
        let i = 0;

        let data = values.reduce((filtered, v) => {
            i++;

            const isSelected = v.reportParamValue === selected;

            // When there is no search query return all values
            if (searchFormatted === '') {
                const entry = {
                    key: v.reportParamValue ?
                        v.reportParamValue :
                        v.reportParamDesc ?
                        v.reportParamDesc :
                        i,
                    label: v.reportParamDesc,
                    value: v.reportParamValue,
                    name: concatParamName(v.reportParamValue, v.reportParamDesc, i),
                    isSelected: isSelected,
                };

                filtered.entries.push(entry);

                if (isSelected) {
                    filtered.selected = entry;
                }

                return filtered;
            }

            // Otherwise check if value and label match search query
            const value = v.reportParamValue === null ?
                '' :
                typeof v.reportParamValue === 'string' ?
                v.reportParamValue.toLowerCase() :
                typeof v.reportParamValue === 'number' ?
                v.reportParamValue.toString() :
                '';
            const label = v.reportParamDesc === null ?
                '' :
                typeof v.reportParamDesc === 'string' ?
                v.reportParamDesc.toLowerCase() :
                typeof v.reportParamDesc === 'number' ?
                v.reportParamDesc.toString() :
                '';

            if (isSelected || value.includes(searchFormatted) || label.includes(searchFormatted)) {
                const entry = {
                    key: v.reportParamValue ?
                        v.reportParamValue :
                        v.reportParamDesc ?
                        v.reportParamDesc :
                        i,
                    label: v.reportParamDesc,
                    value: v.reportParamValue,
                    name: concatParamName(v.reportParamValue, v.reportParamDesc, i),
                    isSelected: isSelected,
                };

                filtered.entries.push(entry);

                if (isSelected) {
                    filtered.selected = entry;
                }
            }

            return filtered;
        }, {
            selected: null,
            entries: [],
        });

        if (data.selected && data.entries.slice(0, 20).findIndex(e => e.value === data.selected.value) === -1) {
            data = {
                ...data,
                entries: [{
                        ...data.selected,
                        key: 'selected ' + data.selected.key,
                    },
                    ...data.entries,
                ],
            }
        }

        return data;
    }
);

const concatParamName = (value, label, id) => {
    if (value && label && value !== label) {
        return [value, label].join(' - ');
    } else if (value && label || label) {
        return label;
    } else if (value) {
        return value;
    } else {
        return '#' + id;
    }
}



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/Form/Autocomplete/List/selectors.js